import { useCallback, useEffect, useState } from 'react';

import { initializeHttpProvider } from '@/providers/HttpProvider/initializeHttpProvider';

import type { IWarehouse } from '@/types/fulfill/warehouse/warehouse.interface';

export const useWarehousesSection = () => {
  const [warehouses, setWarehouses] = useState<IWarehouse[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchActiveWarehouses = useCallback(async () => {
    setIsLoading(true);

    try {
      const http = initializeHttpProvider();
      const response = await http.warehouses.getWarehouses();

      if (!response.success) {
        setError(response.message || 'No se pudieron obtener los almacenes');
        setWarehouses([]);
        return;
      }

      const activeWarehouses = response.data.filter((warehouse) => warehouse.active);

      setWarehouses(activeWarehouses);
      setError(null);
    } catch (fetchError) {
      console.error('Error fetching warehouses:', fetchError);
      setError('Ocurrió un error al cargar los almacenes');
      setWarehouses([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchActiveWarehouses();
  }, [fetchActiveWarehouses]);

  const isEmpty = !isLoading && !error && warehouses.length === 0;

  return {
    warehouses,
    isLoading,
    error,
    isEmpty,
  };
};
